import React from 'react';
import PropTypes from 'prop-types';
import Stamp from './Stamp';

function StampSend({ invoice }) {
  return (
    <Stamp mainText="Надіслано до замовника" subText={invoice} variant="info" />
  );
}

StampSend.propTypes = {
  invoice: PropTypes.string,
};

StampSend.defaultProps = {
  invoice: '',
};

export default StampSend;
